import React, {Component} from 'react';
import {Input} from "reactstrap";
import {ChannelLogo} from "../channels/ChannelLogo";

export class MultiSelectChannelAndTypeItem extends Component {
    constructor(props) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(event) {
        if(this.props.readOnly){
            return;
        }
        this.props.onChange(event);
    }

    renderChannelLogo() {
        if (this.props.channelLogoKey) {
            return (
                <span className="logo" style={{marginRight: 8}}>
                    <ChannelLogo 
                        useOld={false}
                        marginLeft={0}
                        padding={0}
                        width={20}
                        height={20}
                        hspace={0} 
                        vspace={0}
                        channel={this.props.channelLogoKey}
                    />
                </span>
            );
        }
        return null;
    }

    render() {
        return (
            <li key={`li-${this.props.itemId}`}>
                <label className="multi-select-item">
                    <Input 
                        type="checkbox" 
                        onChange={this.handleOnChange}
                        checked={this.props.checked}
                        name={this.props.itemName}
                        data-id={this.props.itemId}
                        readOnly={this.props.readOnly}
                    />
                    <div className="multi-select-item-name">
                        {this.renderChannelLogo()}
                        <span>{this.props.channelName} - {this.props.typeName}</span>
                    </div>
                </label>
            </li>
        );
    }
}

